import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";

export default function FinalCTASection() {
  const { t } = useTranslation();
  const c = t.finalCTA;

  return (
    <section
      id="final-cta"
      className="relative overflow-hidden"
      data-testid="final-cta-section"
      style={{ background: "#0A0A0B" }}
    >
      {/* Gold-Strata background image at 18% opacity */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "url(/Gold-Strata.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.18,
        }}
      />
      {/* Dark overlay for text contrast */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, rgba(10,10,11,0.7) 0%, rgba(10,10,11,0.55) 50%, rgba(10,10,11,0.85) 100%)",
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mb-6 flex items-center justify-center gap-4"
        >
          <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="inline-block w-10 h-px bg-[#C9A96E]"
            style={{ transformOrigin: "center" }}
          />
          <span className="fwd-eyebrow">{c.eyebrow}</span>
          <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="inline-block w-10 h-px bg-[#C9A96E]"
            style={{ transformOrigin: "center" }}
          />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1, ease: "easeOut" }}
          className="fwd-display mb-10"
          data-testid="final-cta-headline"
        >
          {c.headline1}{" "}
          {c.headline2}{" "}
          <span className="fwd-italic-gold">{c.headlineItalic}</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
          className="fwd-body mx-auto mb-12"
          style={{ maxWidth: "720px" }}
          data-testid="final-cta-paragraph"
        >
          {c.paragraph}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
          className="flex justify-center"
        >
          <a
            href="#contact"
            className="fwd-button"
            data-testid="final-cta-button"
          >
            {c.cta}
            <ArrowRight size={18} className="fwd-arrow" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
